import React,{useEffect} from 'react';
import { useNavigate} from 'react-router-dom';
import CommonIn from '../utils/CommonIn';

const Home = () => {
   const navigate = useNavigate();
  
    const navigateToContract = () => {
      navigate("/contract");
    };

  useEffect(() => {
    // CommonIn과 ComponentUtil을 한 번만 호출하도록 수정
    CommonIn();    
  }, []); // Empty dependency array ensures this runs only once after initial render

  return (
     <main>
          <section className="main_visual" id="submain">
          <div className="main_visual_inner">
            <div className="main_visual_text_wrap">
              <div className="main_visual_text" data-aos="fade-up">
                <h1>
                  인공지능과 혁신을 통해<br />
                  모든 출입과 인증을 더 안전하고 간편하게
                </h1>
                <p>
                  드림티원 얼굴인식 기반 인증 기술을 통해 미래형 신뢰 시스템을 구축하고,<br />
                  개인과 조직의 일상적인 인증 과정을 혁신합니다.
                </p>
              </div>
            </div>
            <div className="main_visual_wrap">
              <div className="main_visual_image">
                <video autoPlay loop muted playsInline>
                  <source src="assets/images/visual_vs.mp4" type="video/mp4" />
                  브라우저가 영상을 지원하지 않습니다.
                </video>
              </div>
            </div>  
          </div>
        </section>
        <section className="services" data-aos="fade-up">
          <div className="container">
            <div className="tit" data-aos="fade-up">
              <h3>주요 서비스를 소개합니다</h3>
            </div>
            <div className="tit_info" data-aos="fade-up">
              효율적인 관리와 보안을 위한 최적의 솔루션을 만나보세요.
            </div>
            <div className="services_item_wrap">
              <div className="services_ani" data-aos="fade-up">
                <img src="assets/images/service_img.png" alt="솔루션 이미지" />
              </div>
              <div className="services_items">
                <div className="services_item" data-aos="fade-up">
                  <div className="icon">
                    <img src="assets/images/icon_service01.png" alt="계약 관리 이미지" />
                  </div>
                  <div className="tit">
                    <h4>계약 관리 서비스</h4>
                  </div>
                  <p>
                    전자 서명과 강화된 보안 기술을 갖춘 계약 관리 기능으로 모든 계약 절차가 간소화되고 안전하게 진행됩니다
                  </p>
                </div>
                <div className="services_item" data-aos="fade-up">
                  <div className="icon">
                    <img src="assets/images/icon_service02.png" alt="간편한 일용직 출퇴근 관리 이미지" />
                  </div>
                  <div className="tit">
                    <h4>간편한 일용직 출퇴근 관리</h4>
                  </div>
                  <p>
                    전자 서명과 강화된 보안 기술을 갖춘 계약 관리 기능으로 모든 계약 절차가 간소화되고 안전하게 진행됩니다
                  </p>
                </div>
                <div className="services_item" data-aos="fade-up">
                  <div className="icon">
                    <img src="assets/images/icon_service03.png" alt="효율적 급여 계산 이미지" />
                  </div>
                  <div className="tit">
                    <h4>효율적 급여 계산</h4>
                  </div>
                  <p>
                    전자 서명과 강화된 보안 기술을 갖춘 계약 관리 기능으로 모든 계약 절차가 간소화되고 안전하게 진행됩니다
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="slogan" data-aos="fade-up">
          <div className="container">
            <div className="slogan_txt" data-aos="fade-up">
              <div className="icon_arrow">
                <img src="assets/images/main_icon_arrow.png" alt="up 아이콘" />
              </div>
              <h2>"출입 관리, 근태, 보안 강화로 물류 터미널 효율성과 신뢰도 UP"</h2>
            </div>
            <div className="Partners_logosContainerWrapper">
              <div className="Partners_logosContainer_anibox">
                <div className="Partners_logosRow Partners_moveLeft_left">
                    <img src="../assets/images/logo/logo01.png" alt="Logo 1"/>
                    <img src="../assets/images/logo/logo02.png" alt="Logo 1"/>
                    <img src="../assets/images/logo/logo03.png" alt="Logo 1"/>
                    <img src="../assets/images/logo/logo04.png" alt="Logo 1"/>
                    <img src="../assets/images/logo/logo05.png" alt="Logo 1"/>
                    <img src="../assets/images/logo/logo06.png" alt="Logo 1"/>
                    <img src="../assets/images/logo/logo07.png" alt="Logo 1"/>
                    <img src="../assets/images/logo/logo08.png" alt="Logo 1"/>
                    <img src="../assets/images/logo/logo09.png" alt="Logo 1"/>
                    <img src="../assets/images/logo/logo10.png" alt="Logo 1"/>
                    <img src="../assets/images/logo/logo11.png" alt="Logo 1"/>
                    <img src="../assets/images/logo/logo12.png" alt="Logo 1"/>
                    <img src="../assets/images/logo/logo13.png" alt="Logo 1"/>
                    <img src="../assets/images/logo/logo14.png" alt="Logo 1"/>
                    <img src="../assets/images/logo/logo01.png" alt="Logo 1"/>
                    <img src="../assets/images/logo/logo02.png" alt="Logo 1"/>
                    <img src="../assets/images/logo/logo03.png" alt="Logo 1"/>
                    <img src="../assets/images/logo/logo04.png" alt="Logo 1"/>
                    <img src="../assets/images/logo/logo05.png" alt="Logo 1"/>
                    <img src="../assets/images/logo/logo06.png" alt="Logo 1"/>
                    <img src="../assets/images/logo/logo07.png" alt="Logo 1"/>
                    <img src="../assets/images/logo/logo08.png" alt="Logo 1"/>
                    <img src="../assets/images/logo/logo09.png" alt="Logo 1"/>
                    <img src="../assets/images/logo/logo10.png" alt="Logo 1"/>
                    <img src="../assets/images/logo/logo11.png" alt="Logo 1"/>
                    <img src="../assets/images/logo/logo12.png" alt="Logo 1"/>
                    <img src="../assets/images/logo/logo13.png" alt="Logo 1"/>
                    <img src="../assets/images/logo/logo14.png" alt="Logo 1"/>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="testimonials" data-aos="fade-up">
          <div className="container">
            <h2 data-aos="fade-up">고객과 함께 써 내려간 이야기</h2>
            <p className="tit_info" data-aos="fade-up">"인공지능과 혁신을 통해 물류 터미널의 출입과 인증을 더 안전하고 간편하게, 보안과 효율을 동시에 높였습니다."</p>
            <div className="testimonial_list">
              <div className="testimonial_item" data-aos="fade-up">
                <div className="msg">"출입 관리와 보안 강화로 업무 효율과 신뢰도를 동시에 향상시키다"</div>
                <div className="author">
                  "페이스원 솔루션 도입 후 출입 관리와 근태 기록이 체계적으로 관리되면서 업무 효율성이 눈에 띄게 향상되었습니다.
                  <br/>특히 보안 수준이 강화되어 고객사들에게도 더 큰 신뢰를 줄 수 있었던 점이 매우 만족스럽습니다."
                </div>
              </div>
              <div className="testimonial_item" data-aos="fade-up">
                <div className="msg">"자동화로 관리 부담 해소, 물류 효율성 극대화"</div>
                <div className="author">
                  "페이스원 솔루션 덕분에 출입 관리와 근태 기록 업무가 자동화되면서 관리자의 업무 부담이 크게 줄었습니다. 
                  <br/>물류 처리 속도 향상은 물론, 운영 전반의 효율성을 한 단계 끌어올렸습니다."
                </div>
              </div>
              <div className="testimonial_item" data-aos="fade-up">
                <div className="msg">"얼굴 인식 기술로 보안 강화와 출입 기록의 정확도 혁신"</div>
                <div className="author">
                  "도입 이후 물류센터의 보안이 크게 강화되었고, 얼굴 인식 기술로 출입 기록의 정확도가 놀라울 정도로 개선되었습니다. 
                  <br/>이제 안심하고 운영할 수 있습니다."
                </div>
              </div>
              <div className="testimonial_item" data-aos="fade-up">
                <div className="msg">"정확한 출입 관리로 인한 업무시간 절감"</div>
                <div className="author">
                  "출입 관리 정확도가 95% 이상 향상되고, 관리자 업무 시간이 30% 절감 되었을 때, 이 솔루션의 효과를 실감할 수 있었습니다.
                  <br/>운영 성과가 눈에 띄게 개선되었어요."
                </div>
              </div>
            </div>
            <div className="experience_box" data-aos="fade-up">
              <h3>인공지능과 혁신으로 더 안전하고 간편하게!<br/>지금 무료로 체험해보세요.</h3>
              <button onClick={navigateToContract}>무료체험하기</button>
            </div>
          </div>

        </section>
      </main>
  );
};

export default Home;
